module.exports = __webpack_public_path__ + "img/backMo.05c884f2.jpeg";